import { QueryClient } from '@tanstack/react-query';
import { QueryKeys } from './keysAndFilters';

import { queryClient as globalQueryClient } from '../../../../store/store';

type InvalidateOptions = { refetchActiveQueries?: boolean, queryClient?: QueryClient };

export class WorkspaceQueryInvalidator {
	static invalidateWorkspaceMembers = (
		workspaceID: number,
		{ refetchActiveQueries = false, queryClient = globalQueryClient }: InvalidateOptions = {}
	) => {
		queryClient.invalidateQueries( {
			queryKey: QueryKeys.forWorkspaceMembers( { workspaceID } ),
			refetchType: refetchActiveQueries ? 'active' : 'none'
		} );
	}

	static invalidateNonMembers = (
		workspaceID: number,
		{ refetchActiveQueries = false, queryClient = globalQueryClient }: InvalidateOptions = {}
	) => {
		queryClient.invalidateQueries( {
			queryKey: QueryKeys.forNonMembers( { workspaceID } ),
			refetchType: refetchActiveQueries ? 'active' : 'none'
		} );
	}

	static invalidateMemberAddOnPreview = (
		workspaceID: number,
		{ refetchActiveQueries = false, queryClient = globalQueryClient }: InvalidateOptions = {}
	) => {
		queryClient.invalidateQueries( {
			queryKey: QueryKeys.forMemberAddOnPreviews( { workspaceID } ),
			refetchType: refetchActiveQueries ? 'active' : 'none'
		} );
	}
}
